export const BUSINESS = {
  name: 'OptiAI Consulting',
  shortName: 'OptiAI',
  owner: 'Dragan Živanović',
  url: 'https://optiai.at',
  email: 'office@optiai.at',
  phone: '+43 660 521 9262',
  phoneMachine: '+43-660-521-9262',
  phoneHref: 'tel:+436605219262',
  emailHref: 'mailto:office@optiai.at',
  address: {
    street: 'Moselgasse 26',
    postalCode: '1100',
    locality: 'Wien',
    region: 'Wien',
    country: 'Österreich',
    countryCode: 'AT',
  },
  geo: {
    latitude: 48.1739,
    longitude: 16.382,
  },
  hours: {
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] as const,
    opens: '09:00',
    closes: '18:00',
    label: {
      de: 'Mo–Fr, 09:00–18:00 Uhr',
      en: 'Mon–Fri, 9am–6pm',
    },
  },
  areaServed: ['Österreich', 'Deutschland', 'Schweiz'],
  mapUrl: 'https://maps.google.com/?q=Moselgasse+26+Wien+1100',
  legalBody: 'Wirtschaftskammer Österreich (WKO)',
  registrationLaw: 'Gewerbeordnung (GewO)',
} as const;
